import React from 'react'
import test_image from '@/img/tradly/domains-hd.png'
import Image from 'next/image'

const Workspace = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ">
      <div className="flex items-center justify-between gap-16">
        {/* Section 2 (Image box) */}
        <div className=" w-auto h-auto ">
          <img src={test_image} className="w-full h-full object-container     shadow-custom" />
        </div>

        <div className="w-full h-auto  max-w-[400px]">
          <h2 className="h2 mb-[70px] text-center md:text-start">Workspace</h2>
          <div className="flex flex-col gap-7 ">
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Manage Projects.</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[97%]">
                  Switch between multiple Projects, Add Multiple Domains for a single project. Add
                  custom domain.
                </p>
              </div>
            </div>
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">
                  Layers. Integrations. Templates
                </p>
                <p className="ext-[14px] leading-[22px] font-normal w-[95%]">
                  Add Blogs, System Pages to your platform from workspace. Manage Integrations.
                  Change Templates
                </p>
              </div>
            </div>
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Expand Business</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[98%]">
                  Role Based Access Control(RBAC). Add/Remove Webhooks for Zapier.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Workspace
